import React from "react";
import * as Sentry from "@sentry/react";
import {Button} from "@reside/ui";

import {Banner} from "../banner";

export const ErrorBanner = () => (
  <Banner title="Oops, an error occurred.">
    <Button
      type="link"
      onClick={() => {
        if (import.meta.env.VITE_SENTRY_DSN) {
          Sentry.showReportDialog();
        } else {
          // eslint-disable-next-line no-console
          console.warn("VITE_SENTRY_DSN is missing");
        }
      }}
    >
      Report feedback
    </Button>
  </Banner>
);
